import PromptContent from "slotworks/components/prompt/prompt-content";
import gameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import reelsetModifier from "utils/reelset-modifier";
import GatewayResult from "model/gameplay/records/results/gateway-result";
import MCSpinRecord from "integration/builders/records/mc-spin-record";
import { ChangeMatrixFreespinsCommand } from "commands/change-matrix-freespins-command";
import Layers from "slotworks/graphics/layers/layers";
import { LLCustomLayers } from "../../../lib/luck-and-luxury/src/names";

export default class CGEnterFreespins extends EnterFreespins {

    protected footerMessageKey = "fot.fs";

    public onEnter() {

        const record = gameState.getCurrentGame().getCurrentRecord();
        const gatewayResult = record.getResultsOfType(GatewayResult)[0];

        if (gatewayResult) {
            reelsetModifier.increaseFrequencyOfSymbol("freespins", "WW", gatewayResult.wildsAwarded);
        }

        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("freespins")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("freespins").execute();
        }

        super.onEnter();

        Services.sound.customEvent("start_freespins");

        ChangeMatrixFreespinsCommand(true);

        // TODO: This might come out as part of freespins trigger show wins state
        Services.transaction.setWinnings(gameState.getCurrentGame().getTotalWin()).then(() => {
            this.complete();
        });
    }

    protected showPrompt(prompt?: PromptContent) {
        // Do nothing.
    }
}
